<template>
    <div class="form-type-2 input-quick-search">
        <CustomInput
            :modelValue="quickSearch"
            :inputKey="name"
            :showLabel="true"
            :showDescription="showDescription"
            ref="quickSearch"
            @update:modelValue="onChangedDebounced"
        />
    </div>
</template>

<script>
    import { debounce } from 'lodash';
    import { mapState } from 'pinia';
    import { useCompaniesStore } from '@/stores/companies';
    import CustomInput from '@/components/elements/inputs/CustomInput';

    export default {
        name: "CompaniesQuickSearch",
        components: {
            CustomInput
        },
        data() {
            return {
                name: 'quick_search'
            };
        },
        computed: {
            ...mapState(useCompaniesStore, ['quickSearch', 'audienceId', 'mode']),
            showDescription() {
                return this.mode === 'all' && this.audienceId === null;
            }
        },
        methods: {
            onChangedDebounced: debounce(function (newValue) {
                useCompaniesStore().updateQuickSearch(newValue);
            }, 500),
        }
    }
</script>